import React from "react";
import styled from "@emotion/styled";
import "../styles/loading.scss";
import loadable from "@loadable/component";
const CardCashSpinner = loadable(() =>
  import(/* webpackChunkName: "CardCashSpinner" */ "./CardCashSpinner")
);

const LoaderContainer = styled.div`
  position: relative;
  transform: ${props => props.setTransform};
`;

const WaitPatiently = styled.div`
  font-size: 32px;
  font-weight: 500;
  text-align: center;
  color: #1f2021;
`;

const Processing = styled.div`
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  color: #777984;
`;

const Header = styled.h1`
  font-weight: 500;
  padding-top: 29px;
  padding-bottom: 20px;
`;

const Loading = ({ loadingDisplayCaller }) => (
  <div className="showbox" style={{ zIndex: 112, background: "white" }}>
    <LoaderContainer
      setTransform={
        loadingDisplayCaller ? "translate(0%, 30%)" : "translate(0%, 50%)"
      }
    >
      <CardCashSpinner />
      {loadingDisplayCaller && (
        <WaitPatiently>
          <Header>Hold tight!</Header>
          <Processing>
            We're processing your order, this may take up to 2 minutes.
          </Processing>
        </WaitPatiently>
      )}
    </LoaderContainer>
  </div>
);
export default Loading;
